export default __webpack_public_path__ + "static/media/logo-invision.a1062115.svg";